<template>
  <div class="sheet-block-list-editor">
    <div class="cover"></div>
    <drawer>
      <h2>{{title}}</h2>
      <slot />
      <div v-if="error" class="error">{{error}}</div>

      <template #buttons>
        <button class="error" @click="$emit('cancel')">Annuleer</button>
        <button :disabled="error != null" @click="$emit('save')">Bewaar</button>
      </template>
    </drawer>
  </div>
</template>
<script lang="ts" setup>

import Drawer from '@app/components/Drawer.vue';

defineProps<{
  title:string,
  error:string|null,
}>();

</script>
<style lang="scss">
.sheet-block-list-editor {
  position: fixed;
  z-index: 70;
  
  .cover {
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    position: fixed;
    inset: 0;
    background: rgba(black,0.2);
  }
  .drawer {
    background: var(--pidz-blue);
    padding: 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    position: fixed;
    inset: 0;
    top: auto;
    left: 0;

    h2{
      text-align: center;
      color: var(--pidz-white);
      font-size: 1em;
      margin: 0;
      margin-bottom: 4px;
    }

  }
  div.error {
    background: var(--pidz-white);
    color: var(--pidz-red);
    margin-bottom: 12px;
    padding: 12px;

  }
}
</style>
